/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import { Cell, Grid } from 'styled-css-grid';

import { FormField } from '@xcritical/forms';

import { DictionarySelect, InputFormField } from '@crm-framework/form-fields';
import { Label } from '@crm-framework/label';
import { useRegistry } from '@crm-framework/registry';

import {
  TOOLS_REGISTERS,
  ToolsNotification,
  gridStyles,
} from '@crm-package/tools';

import { FORM_FIELDS } from './consts';
import { IFormResponse } from './models';

export const WithdrawalForm: React.FC = () => {
  const response: IFormResponse = useRegistry(
    TOOLS_REGISTERS.withdrawalResponse
  );

  return (
    <>
      {response ? (
        <ToolsNotification response={response}>
          <div>
            {response.trackingId && (
              <strong>{`Tracking ID: ${response.trackingId}`}</strong>
            )}
            <div>{response.message.replace(/"/g, '')}</div>
          </div>
        </ToolsNotification>
      ) : null}
      <Grid {...gridStyles}>
        <Cell>
          <Label htmlFor={FORM_FIELDS.shopId} isRequired>
            Shop Id
          </Label>
        </Cell>
        <FormField
          name={FORM_FIELDS.shopId}
          component={InputFormField}
          shouldFitContainer
          placeholder="Shop Id"
          id={FORM_FIELDS.shopId}
        />
        <Cell>
          <Label htmlFor={FORM_FIELDS.secretKey} isRequired>
            Secret Key
          </Label>
        </Cell>
        <FormField
          name={FORM_FIELDS.secretKey}
          component={InputFormField}
          shouldFitContainer
          placeholder="Secret Key"
          id={FORM_FIELDS.secretKey}
        />
        <Cell>
          <Label htmlFor={FORM_FIELDS.cardNumber} isRequired>
            Card Number
          </Label>
        </Cell>
        <FormField
          name={FORM_FIELDS.cardNumber}
          component={InputFormField}
          shouldFitContainer
          placeholder="Card Number"
          id={FORM_FIELDS.cardNumber}
        />
        <Cell>
          <Label htmlFor={FORM_FIELDS.amount} isRequired>
            Amount
          </Label>
        </Cell>
        <FormField
          name={FORM_FIELDS.amount}
          component={InputFormField}
          shouldFitContainer
          placeholder="Amount"
          id={FORM_FIELDS.amount}
        />
        <Cell>
          <Label htmlFor={FORM_FIELDS.currency} isRequired>
            Currency
          </Label>
        </Cell>
        <FormField
          name={FORM_FIELDS.currency}
          component={DictionarySelect}
          shouldFitContainer
          dictionaryName="currencies"
          placeholder="Currency"
          inputId={FORM_FIELDS.currency}
          openMenuOnFocus
        />
        <Cell>
          <Label htmlFor={FORM_FIELDS.description} isRequired>
            Description
          </Label>
        </Cell>
        <FormField
          name={FORM_FIELDS.description}
          component={InputFormField}
          shouldFitContainer
          placeholder="Description"
          id={FORM_FIELDS.description}
        />
      </Grid>
    </>
  );
};
